export const parseWidget = (widgetHtml, productId) => {
  try {
    // use dom to parse the html
    const parser = new DOMParser()
    const doc = parser.parseFromString(widgetHtml, 'text/html')
    const parsedObj = { breakdown: {}, reviews: [] }

    const mainWidget = doc.querySelector('.jdgm-rev-widg')
    // BREAKDOWN
    parsedObj.breakdown.averageRating =
      mainWidget.getAttribute('data-average-rating') || null
    parsedObj.breakdown.totalReviews =
      mainWidget.getAttribute('data-number-of-reviews') || null

    // REVIEWS
    const reviews = doc.querySelectorAll('.jdgm-rev')
    reviews.forEach((review) => {
      const reviewObj = {}
      reviewObj.productId = productId
      reviewObj.rating =
        review.querySelector('.jdgm-rev__rating').getAttribute('data-score') ||
        null
      reviewObj.date =
        review
          .querySelector('.jdgm-rev__timestamp')
          .getAttribute('data-content') || null
      reviewObj.author =
        review.querySelector('.jdgm-rev__author').textContent || null
      reviewObj.title =
        review.querySelector('.jdgm-rev__title').textContent || null
      reviewObj.body =
        review.querySelector('.jdgm-rev__body').textContent || null

      reviewObj.reviewId = review.getAttribute('data-review-id') || null
      reviewObj.productTitle = review.getAttribute('data-product-title') || null
      reviewObj.productUrl = review.getAttribute('data-product-url') || null

      // CUSTOM FORM FIELDS
      const customFields = review.querySelectorAll(
        '.jdgm-rev__custom-form .jdgm-rev__cf-ans'
      )
      reviewObj.customFields = []
      customFields.forEach((field) => {
        const title =
          field.querySelector('.jdgm-rev__cf-ans__title').textContent || null
        const value =
          field.querySelector('.jdgm-rev__cf-ans__value').textContent || null
        reviewObj.customFields.push({ title, value })
      })
      parsedObj.reviews.push(reviewObj)
    })

    return parsedObj
  } catch (error) {
    console.error('Error parsing REVIEW widget html', error)
  }
}
